<app-lfsa-card [innTemplate]="enviarTemplateArbol" titulo="Estructura Menú">
</app-lfsa-card>
<ng-template #enviarTemplateArbol>
    <div class="row">
        <div class="col-md-7 float-right">
            <h3>- {{descripcionMenuSuperior}}</h3>
            <ul>
                <h4>- {{descripcionMenuSuperiorNivel2}}</h4>
                <ul>
                    <li *ngFor="let item of rowData">
                        <h5>{{item.descripcion}}</h5>
                    </li>
                </ul>
            </ul>
        </div>
    </div>
</ng-template>

<app-lfsa-card *ngIf="!mostrarFormulario" [innTemplate]="enviarTemplate"
    titulo="Nivel 3 ({{descripcionMenuSuperior}} --> {{descripcionMenuSuperiorNivel2}})">
</app-lfsa-card>
<ng-template #enviarTemplate>
    <br>
    <div class="row">
        <div class="col-md-6">
            <button class="{{diccionarioModulo.button.buttonsCss.danger}}" (click)="goNivel2()">
                <i class="fas fa-arrow-left"></i>
                {{diccionarioModulo.button.buttonsNombre.regresar}}
            </button>
        </div>
        <div class="col-md-6">
            <button id="abrirModal" class="{{diccionarioModulo.button.buttonsCss.success}}"
                (click)="nuevoMostrarModal()">
                <i class="fa fa-plus" aria-hidden="true"></i>
                {{diccionarioModulo.button.buttonsNombre.nuevo}}
            </button>
        </div>
    </div>
    <br>

    <ag-grid-angular [floatingFilter]="true" class="{{diccionarioModulo.agGrid.class}}" #agGrid
        [ngStyle]="diccionarioModulo.agGrid.style" id="{{diccionarioModulo.agGrid.id}}"
        [paginationPageSize]="$any(diccionarioModulo.agGrid).paginacion" [pagination]="true"
        [frameworkComponents]="frameworkComponents" [columnDefs]="columnDefs" [rowSelection]="rowSelection"
        [rowData]="rowData" (gridReady)="onGridReady($event)">
    </ag-grid-angular>

</ng-template>


<app-lfsa-card *ngIf="mostrarFormulario" [innTemplate]="enviarTemplateFormulario" titulo="Agregar/Actualizar Registro">

</app-lfsa-card>
<ng-template #enviarTemplateFormulario>
    <br>
    <form [formGroup]="formulario" novalidate class="form-group">
        <div class="row">
            <div class="col-md-3">
                <app-lfsa-input [claseLabel]="'letrasDanger'" [control]="formulario.get(modelo.descripcion)" [placeholder]="'Menu'"
                    formControlName="{{modelo.descripcion}}" [label]="'Menu Nivel 3*'" [type]="'text'" [id]="'menuN2'">
                </app-lfsa-input>
            </div>
            <div class="col-md-3">
                <app-lfsa-combo-box [claseLabel]="'letrasDanger'" (change)="changeAplicacion($event.target)" [opcion]="'application'"
                    [idOpcion]="'application'" [comboBox]="cmbListAplicacion" formControlName="application"
                    [control]="formulario.get('application')" [label]="'Aplicación'" [id]="'aplicacion'">
                </app-lfsa-combo-box>
            </div>
            <div class="col-md-3">
                <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'descripcion'" [idOpcion]="'id'" [comboBox]="cmbSesion"
                    formControlName="sesionId" [control]="formulario.get('sesionId')" [label]="'Sesión'"
                    [id]="'sesionId'"></app-lfsa-combo-box>
            </div>
            <div class="col-md-3">
                <app-lfsa-input [claseLabel]="'letrasDanger'" [control]="formulario.get(modelo.orden)" [placeholder]="'Orden'"
                    formControlName="{{modelo.orden}}" [label]="'Orden Nivel 3*'" [type]="'number'" [id]="'orden'">
                </app-lfsa-input>
            </div>
        </div>
        <br>
        <app-lfsa-botones-formulario [formularioValido]="formulario.invalid" (devolverAccion)="acciones ( $event )"
            [textBoton]="textBoton"></app-lfsa-botones-formulario>
        <!-- <button [disabled]="formulario.invalid" class="{{diccionarioModulo.button.buttonsCss.success}}">{{diccionarioModulo.button.buttonsNombre.guardar}}</button> -->
    </form>
</ng-template>
<!-- <button type="button" class="btn btn-primary" data-toggle="modal" data-target=".bd-example-modal-lg">Large modal</button> -->
